/* Dopekicks - Buy More Save More engine
   Keeps exactly ONE discount code on the cart: whichever saves the customer more between
   (a) the BMSM tier code the cart qualifies for and
   (b) the customer's own code - typed in the coupon box, applied through a discount link
       (/discount/CODE or ?apply_coupon=CODE), or already sitting on the cart / discount_code cookie.
   The customer's code is remembered, so it is re-compared every time the cart changes.
   Also keeps the link coupon badge (snippets/dk-coupon-badge) in sync with the code that actually won,
   and corrects the progress bar (snippets/dk-bmsm-cart) from the real discount allocations, so a stale
   page cache can never make the bar disagree with the discount.
   Tiers come from window.DKBM_TIERS (snippets/dk-bmsm-settings.liquid). */
(function () {
  if (window.DKBM) return;
  var TIERS = (window.DKBM_TIERS || []).slice().sort(function (a, b) { return a.q - b.q; });
  if (!TIERS.length || !window.fetch) return;
  TIERS.forEach(function (t, i) {
    t.title = 'Buy ' + t.q + (i === TIERS.length - 1 ? '+' : '') + ', Save ' + t.p + '%';
  });

  var USER_KEY = 'dkbm_user', SIG_KEY = 'dkbm_sig', STATE_KEY = 'dkbm_state';
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve();
  var lastCart = null;

  function lc(s) { return String(s || '').toLowerCase(); }
  function isTier(code) { return !!tierOf(code); }
  function tierOf(code) { return TIERS.filter(function (t) { return lc(t.code) === lc(code); })[0] || null; }
  function read(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function store(k, v) { try { if (v) localStorage.setItem(k, v); else localStorage.removeItem(k); } catch (e) {} }
  function sread(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function sstore(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function cookieCode() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function json(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }
  function getCart() { return nativeFetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(json); }
  function setDiscount(code) {
    return nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code || '' })
    }).then(json);
  }
  function codes(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }
  function codeKey(cart) { return codes(cart).map(lc).join(','); }
  function hit(cart, code) { return (cart.discount_codes || []).filter(function (d) { return lc(d.code) === lc(code); })[0]; }

  /* ---------- Progress bar correction ----------
     When a tier code is on the cart, every eligible line carries an allocation from it,
     so the eligible quantity is exactly the quantity of those lines. */
  function eligibleFromCart(cart) {
    if (!cart) return null;
    var tierCode = codes(cart).filter(function (c) {
      var h = hit(cart, c); return isTier(c) && h && h.applicable;
    })[0];
    if (!tierCode) return null;
    var n = 0;
    (cart.items || []).forEach(function (it) {
      var has = (it.discounts || []).some(function (d) { return lc(d.title) === lc(tierCode); }) ||
        (it.line_level_discount_allocations || []).some(function (a) {
          return a.discount_application && lc(a.discount_application.title) === lc(tierCode);
        });
      if (has) n += it.quantity;
    });
    return n || null;
  }

  function paintBar(el, qty) {
    var maxQ = TIERS[TIERS.length - 1].q, cur = 0, next = null;
    TIERS.forEach(function (t) {
      if (qty >= t.q) cur = t.p; else if (!next) next = t;
    });
    var msg = el.querySelector('.dkbm__msg');
    if (msg) {
      if (!next) {
        msg.innerHTML = '<strong>' + cur + '% OFF unlocked</strong> &mdash; you\'ve got our best deal!';
      } else {
        var left = next.q - qty;
        msg.innerHTML = (cur > 0 ? '<strong>' + cur + '% OFF unlocked!</strong> ' : '') +
          'Add <strong>' + left + ' more ' + (left === 1 ? 'item' : 'items') + '</strong> to get <strong class="dkbm__hl">' + next.p + '% OFF</strong>';
      }
    }
    el.classList.toggle('is-max', !next);
    var fill = el.querySelector('.dkbm__fill');
    if (fill) fill.style.width = Math.round(Math.min(qty, maxQ) * 100 / maxQ) + '%';
    var track = el.querySelector('.dkbm__track');
    if (track) track.setAttribute('aria-valuenow', Math.min(qty, maxQ));
    el.querySelectorAll('.dkbm__dot').forEach(function (d, i) {
      if (TIERS[i]) d.classList.toggle('is-on', qty >= TIERS[i].q);
    });
    el.setAttribute('data-dkbm-qty', qty);
  }

  function fixBars() {
    var q = eligibleFromCart(lastCart);
    if (q == null) return;
    document.querySelectorAll('.dkbm--cart').forEach(function (el) {
      if (el.getAttribute('data-dkbm-qty') !== String(q)) paintBar(el, q);
    });
  }

  /* Put ONE code on the cart and report what it saves (-1 = not valid for this cart) */
  function trial(code) {
    return setDiscount(code).then(function (cart) {
      var h = hit(cart, code);
      return { code: code, cart: cart, saving: h && h.applicable ? cart.total_discount : -1 };
    });
  }

  /* Highest tier the cart qualifies for. Starts from the item count and steps down,
     so products outside the eligible collection (not counted by Shopify) are handled here. */
  function bestTier(count) {
    var list = TIERS.filter(function (t) { return t.q <= count; }).reverse();
    var i = 0;
    function next() {
      if (i >= list.length) return Promise.resolve(null);
      var t = list[i++];
      return trial(t.code).then(function (r) { return r.saving > 0 ? r : next(); });
    }
    return next();
  }

  /* The customer's own code: anything on the cart that isn't a tier code (discount links land here),
     else the remembered one, else the discount_code cookie set by a discount link. */
  function userCode(cart) {
    var foreign = codes(cart).filter(function (c) { return !isTier(c); });
    if (foreign.length) store(USER_KEY, foreign[foreign.length - 1]);
    var u = read(USER_KEY);
    if (!u) {
      var ck = cookieCode();
      if (ck && !isTier(ck)) { u = ck; store(USER_KEY, u); }
    }
    return u;
  }

  function sig(cart, user) {
    return [cart.token, cart.item_count, cart.original_total_price, lc(user), codeKey(cart)].join('|');
  }

  /* Link coupon badge: show the code that is really on the cart */
  function syncBadge(state) {
    var el = document.querySelector('.dk-coupon');
    if (!el || !state) return;
    var codeEl = el.querySelector('.dk-code');
    if (!codeEl) return;
    var l = el.querySelector('.dk-msg-l'), s = el.querySelector('.dk-msg-s');
    if (!el.dataset.dkbmOrig) {
      el.dataset.dkbmOrig = JSON.stringify({ c: codeEl.textContent, l: l ? l.textContent : '', s: s ? s.textContent : '' });
    }
    var orig = JSON.parse(el.dataset.dkbmOrig);
    if (state.kind === 'tier' && state.title) {
      codeEl.textContent = String(state.code).toUpperCase();
      if (l) l.textContent = 'Better deal applied: ' + state.title + '.';
      if (s) s.textContent = state.title;
    } else {
      codeEl.textContent = orig.c;
      if (l) l.textContent = orig.l;
      if (s) s.textContent = orig.s;
    }
  }

  function resolve(cart, user) {
    var before = codeKey(cart), startDisc = cart.total_discount;
    var tierRes = null, userRes = null;
    return bestTier(cart.item_count).then(function (t) {
      tierRes = t;
      return user ? trial(user) : null;
    }).then(function (u) {
      userRes = u;
      var ts = tierRes ? tierRes.saving : 0;
      var us = userRes ? userRes.saving : -1;
      var winner = '', kind = 'none';
      if (us > 0 && us >= ts) { winner = user; kind = 'user'; }
      else if (ts > 0) { winner = tierRes.code; kind = 'tier'; }

      var last = userRes || tierRes;
      var done;
      if (last && winner && lc(last.code) === lc(winner)) done = Promise.resolve(last.cart);
      else if (last || before) done = setDiscount(winner);
      else done = Promise.resolve(cart);

      return done.then(function (finalCart) {
        var tier = tierRes ? tierOf(tierRes.code) : null;
        var state = { kind: kind, code: winner, title: kind === 'tier' && tier ? tier.title : '' };
        lastCart = finalCart;
        sstore(SIG_KEY, sig(finalCart, user));
        sstore(STATE_KEY, JSON.stringify(state));
        syncBadge(state);
        return {
          cart: finalCart,
          changed: codeKey(finalCart) !== before || finalCart.total_discount !== startDisc,
          kind: kind,
          winner: winner,
          user: user,
          userSaving: us,
          tierSaving: ts,
          tier: tier
        };
      });
    });
  }

  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }

  function emit(r) {
    fixBars();
    if (r) document.dispatchEvent(new CustomEvent('dkbm:resolved', { detail: r }));
  }

  function pick(html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); }

  /* Re-render everything that shows cart totals (drawer + cart page) */
  function refresh() {
    var jobs = [];
    var drawer = document.getElementById('mini-cart-drawer');
    if (drawer) {
      jobs.push(nativeFetch('/?sections=mini-cart-drawer').then(json).then(function (j) {
        var el = j['mini-cart-drawer'] && pick(j['mini-cart-drawer'], '.shopify-section');
        if (el) drawer.innerHTML = el.innerHTML;
      }));
    }
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && footer && items.dataset.id && footer.dataset.id) {
      var ids = [items.dataset.id, footer.dataset.id];
      jobs.push(nativeFetch('/cart?sections=' + ids.join(',')).then(json).then(function (j) {
        [[items, ids[0]], [footer, ids[1]]].forEach(function (p) {
          var fresh = j[p[1]] && pick(j[p[1]], '.js-contents');
          var cur = p[0].querySelector('.js-contents');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      }));
    }
    return Promise.all(jobs).catch(function () {}).then(fixBars);
  }

  function evaluate(force) {
    return enqueue(function () {
      return getCart().then(function (cart) {
        lastCart = cart;
        var user = userCode(cart);
        if (!force && sig(cart, user) === sread(SIG_KEY)) { fixBars(); return null; }
        return resolve(cart, user).then(function (r) {
          return (r.changed ? refresh() : Promise.resolve()).then(function () { emit(r); return r; });
        });
      });
    }).catch(function () { return null; });
  }

  /* Coupon box -> returns { status: 'applied' | 'worse' | 'invalid', result } */
  function applyUserCode(code) {
    return enqueue(function () {
      if (isTier(code)) {
        return getCart().then(function (cart) { return resolve(cart, read(USER_KEY)); }).then(function (r) {
          return refresh().then(function () {
            emit(r);
            return { status: lc(r.winner) === lc(code) ? 'applied' : (r.kind !== 'none' ? 'worse' : 'invalid'), result: r };
          });
        });
      }
      return trial(code).then(function (t) {
        if (t.saving < 0) {
          return resolve(t.cart, read(USER_KEY)).then(function (r) {
            return refresh().then(function () { emit(r); return { status: 'invalid', result: r }; });
          });
        }
        store(USER_KEY, code);
        return resolve(t.cart, code).then(function (r) {
          return refresh().then(function () {
            emit(r);
            return { status: r.kind === 'user' ? 'applied' : 'worse', result: r };
          });
        });
      });
    });
  }

  /* Coupon box remove (x on a chip) */
  function removeCode(code) {
    return enqueue(function () {
      if (lc(read(USER_KEY)) === lc(code)) store(USER_KEY, '');
      if (lc(cookieCode()) === lc(code)) document.cookie = 'discount_code=; path=/; max-age=0';
      try {
        var d = JSON.parse(localStorage.getItem('dk_coupon') || 'null');
        if (d && lc(d.code) === lc(code)) localStorage.removeItem('dk_coupon');
      } catch (e) {}
      return setDiscount('').then(function (cart) { return resolve(cart, read(USER_KEY)); }).then(function (r) {
        return refresh().then(function () { emit(r); return r; });
      });
    });
  }

  /* Re-check whenever anything else changes the cart (theme add to cart, qty +/-, remove, apps) */
  var timer;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { evaluate(false); }, 400); }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(schedule, function () {});
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url))) this.addEventListener('load', schedule);
    return xhrOpen.apply(this, arguments);
  };

  /* The theme re-renders the drawer on its own (add to cart, qty +/-): repaint the bar when it does */
  var barTimer;
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.dkbm--cart') || n.querySelector('.dkbm--cart'))) {
            clearTimeout(barTimer); barTimer = setTimeout(fixBars, 50); return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.DKBM = {
    tiers: TIERS,
    isTier: isTier,
    tierOf: tierOf,
    money: money,
    evaluate: evaluate,
    applyUserCode: applyUserCode,
    removeCode: removeCode,
    refresh: refresh,
    fixBars: fixBars
  };

  function boot() {
    var st = null;
    try { st = JSON.parse(sread(STATE_KEY) || 'null'); } catch (e) {}
    if (st) { syncBadge(st); setTimeout(function () { syncBadge(st); }, 800); }
    evaluate(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('pageshow', function (e) { if (e.persisted) evaluate(true); });
})();
